export default __webpack_public_path__ + "static/media/hospital.e9ace98e.webp";